import React, {FC} from 'react';
import {ErrorBoundary} from 'react-error-boundary';

import {KnowledgeBasePluginPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {SidePanelCloseButton} from '../inboxes/side/sidePanelCloseButton';
import {KnowledgeBasePluginErrorBoundary} from './knowledgeBasePluginErrorBoundary';
import {KnowledgeBasePluginPreferencesContainer} from './knowledgeBasePluginPreferencesContainer';

/*
 * Props.
 */

interface KnowledgeBasePopupPluginContainerProps {
  panelId: KnowledgeBasePluginPanelId;
  onClose: () => void;
}

/*
 * Component.
 */

export const KnowledgeBasePopupPluginContainer: FC<KnowledgeBasePopupPluginContainerProps> = ({
  panelId,
  onClose,
}) => (
  // TODO: Add proper reset support to the popped out panel.
  //       Currently we will just close the panel if it errors out.
  <ErrorBoundary fallbackRender={KnowledgeBasePluginErrorBoundary} onReset={onClose}>
    <KnowledgeBasePluginPreferencesContainer
      panelId={panelId}
      sidepanelCloseButton={<SidePanelCloseButton onClose={onClose} />}
    />
  </ErrorBoundary>
);
